import { render, staticRenderFns } from "./materialPurchase.vue?vue&type=template&id=3154fc98&scoped=true"
import script from "./materialPurchase.vue?vue&type=script&lang=js"
export * from "./materialPurchase.vue?vue&type=script&lang=js"
import style0 from "./materialPurchase.vue?vue&type=style&index=0&id=3154fc98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154fc98",
  null
  
)

export default component.exports